/* eslint-disable no-dupe-keys */
export default {
  header: {
    home: 'Início',
    history: 'História',
    suppliers: 'Fornecedores',
    shop: 'Loja',
    career: 'Carreira',
    contactUs: 'Contate-nos',
    callUsToday: 'Ligue hoje',
    chatWithUs: 'Fale conosco',
    signIn: 'Entrar',
    search: 'Buscar',
    searchPlaceholder: 'Buscar produtos...',
    searchProducts: 'Buscar Produtos',
    close: 'Fechar',
    greeting: 'Olá',
    myAccount: 'Minha Conta',
    logout: 'Sair',
    noProductsFound: 'Nenhum produto encontrado',
    tryAnotherSearch: 'Tente buscar com outros termos'
  },
  auth: {
    signIn: 'ENTRAR',
    signUp: 'CADASTRAR',
    email: 'E-mail',
    username: 'Usuário',
    password: 'Senha',
    forgotPassword: 'Esqueceu sua senha?',
    dontHaveAccount: 'Ainda não tem uma conta?',
    signUpFree: 'Cadastre-se gratuitamente',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    confirmPassword: 'Confirmar Senha',
    create: 'CRIAR',
    alreadyHaveAccount: 'Já tem uma conta?',
    allFieldsRequired: 'Por favor, preencha todos os campos obrigatórios',
    passwordsDoNotMatch: 'As senhas não coincidem',
    signupError: 'Erro ao criar conta. Por favor, tente novamente.',
    loading: 'Carregando...',
    signupSuccess: 'Conta criada com sucesso! Bem-vindo!',
    firstNamePlaceholder: 'Digite seu nome',
    lastNamePlaceholder: 'Digite seu sobrenome',
    emailPlaceholder: 'Digite seu e-mail',
    usernamePlaceholder: 'Digite seu usuário',
    selectProject: 'Selecione um Projeto',
    project: 'Projeto',
    selectProjectPlaceholder: 'Selecione um projeto',
    location: 'Filial',
    selectLocationPlaceholder: 'Selecione uma filial',
    confirm: 'Confirmar',
    close: 'Fechar',
    loadingProjects: 'Carregando projetos...',
    projectLoadError: 'Erro ao carregar projetos. Tente novamente.',
    locationLoadError: 'Erro ao carregar filiais. Tente novamente.',
    retry: 'Tentar novamente',
    noProjectsFound: 'Nenhum projeto encontrado para este usuário.',
    selectLocation: 'Selecione uma Filial',
    selectLocationToContinue: 'Por favor, selecione uma filial para continuar.',
    passwordPlaceholder: 'Digite sua senha',
    confirmPasswordPlaceholder: 'Confirme sua senha',
    forgotPasswordTitle: 'ESQUECI MINHA SENHA',
    forgotPasswordInstruction: 'Digite seu e-mail e enviaremos um link para redefinir sua senha.',
    sendResetLink: 'ENVIAR LINK',
    backToLogin: 'Voltar para o login',
    resetLinkSent: 'Link de redefinição de senha enviado para seu e-mail.',
    resetLinkError: 'Erro ao enviar o link. Tente novamente.',
    emailRequired: 'E-mail é obrigatório',
    resetPasswordTitle: 'REDEFINIR SENHA',
    newPassword: 'Nova senha',
    resetPassword: 'REDEFINIR SENHA',
    passwordResetSuccess: 'Senha redefinida com sucesso. Redirecionando para o login...',
    passwordResetError: 'Erro ao redefinir a senha. Tente novamente.',
    fieldRequired: 'Este campo é obrigatório',
    signup: 'CADASTRAR',
    invalidCredentials: 'Credenciais inválidas',
    loginError: 'Erro ao fazer login. Tente novamente.',
    noProjectsTitle: 'Acesso Negado',
    noProjectsMessage: 'Você não possui projetos associados à sua conta e não pode acessar o sistema.',
    noProjectsContact: 'Entre em contato com o administrador para solicitar acesso a um projeto.',
    understood: 'Entendi',
    passwordTooShort: 'A senha deve ter pelo menos 6 caracteres',
    selectProject: 'Selecione um Projeto',
    project: 'Projeto',
    selectProjectPlaceholder: 'Selecione um projeto',
    confirm: 'CONFIRMAR'
  },
  cart: {
    shoppingCart: 'CARRINHO DE COMPRAS',
    subtotal: 'SUBTOTAL',
    taxesAndShipping: 'Impostos e frete calculados no checkout',
    checkout: 'CHECKOUT',
    orderSummary: 'RESUMO DO PEDIDO',
    shipping: 'Frete',
    total: 'TOTAL',
    viewCart: 'VER CARRINHO',
    close: 'Fechar',
    decrease: 'Diminuir quantidade',
    increase: 'Aumentar quantidade',
    remove: 'Remover item',
    addToCart: 'ADICIONAR',
    addCart: 'ADICIONAR AO CARRINHO',
    quantity: 'Quantidade',
    productAdded: "Produto adicionado ao carrinho com sucesso!",
    emptyCart: "Seu carrinho está vazio",
    freeShipping: "Frete Grátis"
  },
  shoppingCart: {
    title: 'CARRINHO DE COMPRAS',
    subtotal: 'SUBTOTAL',
    taxesAndShipping: 'Impostos e frete calculados no checkout',
    checkout: 'FINALIZAR COMPRA',
    product: 'Produto',
    addNotes: 'Adicionar observações',
    notesPlaceholder: 'Adicione suas observações aqui...',
    quantity: 'Quantidade',
    total: 'TOTAL',
    continueShopping: "CONTINUAR COMPRANDO"
  },
  categories: {
    shopByCategories: 'COMPRE POR CATEGORIAS',
    title: 'CATEGORIAS',
    price: 'PREÇO',
    brands: 'MARCAS',
    sortBy: {
      featured: 'Ordenar por Destaque',
      priceLowHigh: 'Preço: Menor para Maior',
      priceHighLow: 'Preço: Maior para Menor',
      nameAZ: 'Nome: A a Z',
      nameZA: 'Nome: Z a A'
    },
    showing: 'Mostrando {count} resultados'
  },
  hero: {
    bestShop: 'Sua Melhor Loja Online',
    specialOffers: 'Ofertas Especiais',
    newCollection: 'Nova Coleção',
    shopNow: 'Comprar Agora'
  },
  products: {
    newProducts: 'NOVOS PRODUTOS',
    outOfStock: 'Fora de Estoque',
    price: 'Preço',
    // eslint-disable-next-line no-dupe-keys
    description: 'Descrição',
    noProductsFound: 'Nenhum produto encontrado',
    priceOnRequest: 'Sob consulta',
    priceToConsult: 'Sob consultar'
  },
  productSearch: {
    title: 'Adicionar Produtos ao Carrinho',
    searchPlaceholder: 'Buscar produtos para adicionar ao carrinho...',
    noResults: 'Nenhum produto encontrado. Tente outra busca.',
    addToCart: 'Adicionar'
  },
  common: {
    previous: 'Anterior',
    next: 'Próximo',
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    cancel: 'Cancelar',
    save: 'Salvar',
    saving: 'Salvando...',
    update: 'Atualizar',
    delete: 'Excluir',
    edit: 'Editar',
    close: 'Fechar',
    back: 'Voltar',
    saving: 'Salvando...',
    updating: 'Atualizando...',
    deleting: 'Excluindo...',
    retry: 'Tentar novamente',
    myAccount: 'Minha Conta'
  },
  checkout: {
    title: 'CHECKOUT',
    poNumber: 'P.O. Number',
    poNumberPlaceholder: 'Digite o número do P.O...',
    location: 'Order Location',
    selectLocation: 'Selecione a localização',
    deliveryMethod: 'Método de Entrega',
    delivery: 'Delivery',
    pickup: 'Pick-up',
    pickupDisabledNoProject: 'A retirada requer um projeto associado',
    pickupRequiresProject: 'A retirada está disponível apenas para clientes com um projeto associado',
    companyAddresses: 'Endereços da Empresa',
    selectCompanyAddress: 'Selecione um endereço',
    useThisAddress: 'Usar este endereço',
    personalDetails: 'Dados Pessoais',
    firstName: 'Nome',
    firstNamePlaceholder: 'Digite seu nome...',
    lastName: 'Sobrenome',
    lastNamePlaceholder: 'Digite seu sobrenome...',
    email: 'E-mail',
    emailPlaceholder: 'Digite seu e-mail...',
    phone: 'Telefone',
    phonePlaceholder: 'Digite seu telefone...',
    emptyCart: 'Seu carrinho está vazio',
    continueShopping: 'CONTINUAR COMPRANDO',

    shippingDetails: 'Detalhes de Envio',
    address: 'Endereço',
    addressPlaceholder: 'Digite seu endereço...',
    number: 'Número',
    numberPlaceholder: 'Digite o número...',
    apartment: 'Complemento',
    apartmentPlaceholder: 'Digite o complemento...',
    city: 'Cidade',
    cityPlaceholder: 'Digite sua cidade...',
    state: 'Estado',
    statePlaceholder: 'Selecione seu estado...',
    postalCode: 'CEP',
    postalCodePlaceholder: 'Digite seu CEP...',
    country: 'País',
    countryPlaceholder: 'Selecione seu país...',

    paymentDetails: 'Dados de Pagamento',
    cardHolder: 'Titular do Cartão',
    cardHolderPlaceholder: 'Nome completo no cartão...',
    cardNumber: 'Número do Cartão',
    cardNumberPlaceholder: 'Digite o número do cartão...',
    expiryDate: 'Data de Validade',
    expiryDatePlaceholder: 'MM/AA',
    cvv: 'CVV',
    cvvPlaceholder: '123',


    completePurchase: 'FINALIZAR PEDIDO',
    fieldRequired: 'Este campo é obrigatório',
    emptyCart: "Seu carrinho está vazio",
    continueShopping: "CONTINUAR COMPRANDO",
    summary: {
      title: "RESUMO DO PEDIDO",
      taxes: "IMPOSTOS",
      shipping: "FRETE",
      total: "TOTAL",
      freeShipping: "Frete Grátis"
    },
    errorLoadingAddress: 'Erro ao carregar endereço padrão',
    errorLoadingLocations: 'Erro ao carregar locais',
    selectLocation: 'Selecionar local',
    location: 'Local',
    pickupLocation: 'Local de Retirada',
    changeLocation: 'Alterar local',
    useThisLocation: 'Usar este local',
    noLocationsFound: 'Nenhum local encontrado',
    changeAddress: 'Alterar endereço',
    selectAddress: 'Selecione o endereço de entrega',
    useThisAddress: 'Usar este endereço',
    manageAddresses: 'Gerenciar endereços',
    calculating: "Calculando",
    processing: "Processando",
    errorCalculating: "Erro ao calcular valores",
    errorProcessingOrder: "Erro ao processar pedido",
    neighborhood: 'Bairro',
    neighborhoodPlaceholder: 'Digite seu bairro',
    minOrderValueMessage: 'O valor mínimo do pedido é {value}. Por favor, adicione mais itens ao seu carrinho.',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Telefone',
    firstNamePlaceholder: 'Digite seu nome',
    lastNamePlaceholder: 'Digite seu sobrenome',
    emailPlaceholder: 'Digite seu e-mail',
    phonePlaceholder: 'Digite seu telefone',
    addressLine1: 'Endereço Linha 1',
    addressLine1Placeholder: 'Digite o endereço',
    addressLine2: 'Endereço Linha 2',
    addressLine2Placeholder: 'Digite informações adicionais do endereço',
    city: 'Cidade',
    cityPlaceholder: 'Digite a cidade',
    state: 'Estado',
    statePlaceholder: 'Digite o estado',
    postalCode: 'Código Postal',
    postalCodePlaceholder: 'Digite o código postal',
    country: 'País',
    countryPlaceholder: 'Digite o país',
    selectCountry: 'Selecione o país',
    selectState: 'Selecione o estado',
    errorLoadingCountries: 'Erro ao carregar países',
    errorLoadingStates: 'Erro ao carregar estados',
    invalidDate: 'Data inválida. Por favor, selecione uma data válida (a partir de amanhã)',
    contactOnSite: 'Contato no Local',
    contactOnSitePlaceholder: 'Digite o nome do contato',
    contactPhone: 'Telefone de Contato',
    contactPhonePlaceholder: 'Digite o telefone de contato',
    deliveryDate: 'Data de Entrega',
    deliveryDatePlaceholder: 'Selecione a data de entrega...',
    pickupDate: 'Data de Retirada',
    pickupDatePlaceholder: 'Selecione a data de retirada...',
    specialInstructions: 'Instruções Especiais de Entrega',
    specialInstructionsPlaceholder: 'Ex.: entrega no cais, entrega nos fundos',
    specialInstructionsPickup: 'Instruções Especiais de Retirada',
    specialInstructionsPlaceholderPickup: 'Ex.: horário de retirada, veículo, acesso ao pátio...',
    shippingDetails: 'Detalhes de Entrega',
    confirmProject: {
      title: 'Confirmação de Projeto',
      message: 'Você está finalizando o pedido para o projeto:',
      confirm: 'Confirmar e Continuar',
      changeProject: 'Selecionar Outro Projeto',
      applyChange: 'Aplicar Alteração',
      loadingProjects: 'Carregando projetos...',
      loadError: 'Erro ao carregar projetos. Tente novamente.',
      retry: 'Tentar novamente',
      noProjectsFound: 'Nenhum projeto encontrado para este usuário.'
    },
    confirmLocation: {
      message: 'E para a filial:',
      changeLocation: 'Selecionar Outra Filial',
      applyChange: 'Aplicar Alteração',
      loadingLocations: 'Carregando filiais...',
      loadError: 'Erro ao carregar filiais. Tente novamente.',
      retry: 'Tentar novamente',
      noLocationsFound: 'Nenhuma filial encontrada.'
    }
  },
  thankYou: {
    title: 'OBRIGADO PELO SEU PEDIDO!',
    orderNumber: 'Pedido #',
    emailConfirmation: 'Enviamos um e-mail de confirmação para sua caixa de entrada com todos os detalhes da sua compra.',
    continueShopping: 'CONTINUAR COMPRANDO'
  },
  footer: {
    titles: {
      products: 'PRODUTOS',
      contactUs: 'CONTATE-NOS'
    },
    navigation: {
      home: 'Início',
      history: 'História',
      suppliers: 'Fornecedores',
      career: 'Carreira',
      heating: 'Aquecimento',
      tools: 'Ferramentas'
    },
    contact: {
      email: 'info@empirecanada.ca',
      address: '2320, rue Cohen, Saint-Laurent, QC H4R 2N8'
    },
    allRightsReserved: 'Todos os Direitos Reservados'
  },
  contact: {
    title: 'Contate-nos',
    info: {
      title: 'Informações de Contato',
      phone: '+1 (514) 123-4567',
      email: 'info@empirecanada.ca',
      address: '2320, rue Cohen, Saint-Laurent, QC H4R 2N8'
    },
    email: 'info@empirecanada.ca',
    form: {
      title: 'Envie-nos uma Mensagem',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      subject: 'Assunto',
      selectSubject: 'Selecione um assunto',
      subjects: {
        general: 'Consulta Geral',
        support: 'Suporte Técnico',
        sales: 'Vendas',
        other: 'Outro',
        jobApplication: 'Candidatura para Vaga'
      },
      message: 'Mensagem',
      submit: 'Enviar Mensagem',
      resume: 'Currículo',
      chooseFile: 'Escolher Arquivo',
      noFileChosen: 'Nenhum arquivo selecionado',
      acceptedFormats: 'Formatos aceitos: PDF, DOC, DOCX (máx 5MB)',
      resumeRequired: 'Por favor, anexe seu currículo',
      invalidFileType: 'Tipo de arquivo inválido. Por favor, envie um documento PDF ou Word.',
      fileTooLarge: 'Arquivo muito grande. Tamanho máximo é 5MB.',
      submitSuccess: 'Sua mensagem foi enviada com sucesso!',
      submitError: 'Ocorreu um erro ao enviar sua mensagem. Por favor, tente novamente.',
      jobApplicationMessage: 'Gostaria de me candidatar à vaga'
    }
  },
  productDetails: {
    addToCart: 'ADICIONAR AO CARRINHO',
    shopNow: 'COMPRAR AGORA',
    selectColor: 'Cor',
    selectSize: 'Tamanho',
    selectWeight: "Selecionar Peso",
    selectUnit: 'Unidade de Medida',
    // eslint-disable-next-line no-dupe-keys
    description: 'DESCRIÇÃO',
    bestSellers: 'MAIS VENDIDOS',
    addCart: 'ADICIONAR',
    productName: 'Nome do Produto',
    shippingInfo: 'Informações de Envio',
    freeShipping: 'Frete grátis para pedidos acima de R$ 200,00',
    selectOptions: 'Por favor, selecione cor e tamanho',
    noDescription: 'Nenhuma descrição técnica disponível para este produto.',
    requiredField: 'Este campo é obrigatório',
    selectRequiredCharacteristics: 'Por favor, selecione todas as características obrigatórias antes de adicionar ao carrinho',
    stock: {
      title: 'Estoque',
      loading: 'Carregando informações de estoque...',
      noLocations: 'Nenhuma localização disponível',
      noStock: 'SEM ESTOQUE',
      quantityToConfirm: 'Quantidade a confirmar',
      inventoryToConfirm: 'Inventário a confirmar',
      unitsAvailable: '{count} unidades disponíveis',
      unitAvailable: '1 unidade disponível',
      selectLocation: 'Selecione uma localização para comprar',
      quantityExceeded: 'A quantidade solicitada ({requested}) excede o estoque disponível ({available}) na localização selecionada.',
      location1: { title: 'Quebec Les Saules, QC Corredor 17.', subtitle: '80 itens disponíveis em estoque' },
      location2: { title: 'Quebec Les Saules, QC Corredor 17.', subtitle: '80 itens disponíveis em estoque' },
      location3: { title: 'Quebec Les Saules, QC Corredor 17.', subtitle: '80 itens disponíveis em estoque' }
    }
  },
  categoryPage: {
    filters: 'FILTROS',
    clearAll: 'Limpar Tudo',
    categories: 'CATEGORIAS',
    price: 'PREÇO',
    brands: 'MARCAS',
    sortBy: {
      label: 'Ordenar por',
      featured: 'Ordenar por Destaque',
      priceLowHigh: 'Preço: Menor para Maior',
      priceHighLow: 'Preço: Maior para Menor',
      nameAZ: 'Nome: A a Z',
      nameZA: 'Nome: Z a A'
    },
    showingResults: 'Mostrando {count} resultados',
    itemsCount: 'Mostrando {start}-{end} de {total} itens',
    previous: 'Anterior',
    next: 'Próximo',
    addToCart: 'ADICIONAR AO CARRINHO',
    outOfStock: 'Fora de Estoque',
    noResults: 'Não encontramos nenhum produto',
    searchCategories: 'Buscar categorias...',
    showOnlyCategoriesWithProducts: 'Mostrar apenas categorias com produtos',
    noCategories: 'Nenhuma categoria encontrada',
    branches: 'FILIAIS',
    filterBy: 'FILTRAR POR',
    searchPlaceholderShort: 'Buscar',
    noBranches: 'Nenhuma filial disponível',
    noAdditionalFilters: 'Nenhum filtro adicional disponível',
    noBrandsFound: 'Nenhuma marca encontrada',
    keywords: 'Palavras-chave',
    selectedFilters: 'Filtros selecionados',
    clearFilters: 'Limpar tudo',
    removeFilter: 'Remover filtro {name}',
    dynamicFilters: {
      searchPlaceholder: 'Pesquisar...',
      noResultsFound: 'Nenhum resultado encontrado',
      noOptionsAvailable: 'Nenhuma opção disponível',
      showMore: 'Mostrar mais',
      showLess: 'Mostrar menos'
    },
    onlyInStock: 'Somente em estoque',
    didYouMean: 'Você quis dizer',
    noResultsDetailed: 'Busca: 0 resultados encontrados para "{terms}"',
    display: 'Exibição:',
    resultsCount: '{count} resultados'
  },
  career: {
    title: 'Oportunidades de Carreira',
    whyJoin: {
      title: 'Por Que Se Juntar a Nossa Equipe?',
      benefit1: 'Salário e benefícios competitivos',
      benefit2: 'Oportunidades de crescimento e desenvolvimento profissional',
      benefit3: 'Ambiente de trabalho dinâmico e inovador',
      benefit4: 'Equilíbrio entre trabalho e vida pessoal com horário flexível'
    },
    openings: {
      title: 'Vagas Disponíveis',
      position1: {
        title: 'Desenvolvedor de Software',
        description: 'Junte-se à nossa equipe de desenvolvimento para criar soluções inovadoras usando tecnologias de ponta.'
      },
      position2: {
        title: 'Designer UX/UI',
        description: 'Ajude-nos a criar experiências de usuário bonitas e intuitivas para nossos produtos digitais.'
      },
      position3: {
        title: 'Gerente de Produto',
        description: 'Lidere a estratégia e desenvolvimento de produtos para entregar valor excepcional aos nossos clientes.'
      }
    },
    loading: 'Carregando...',
    fetchError: 'Erro ao carregar carreiras.',
    apply: 'Candidatar-se'
  },
  myAccount: {
    title: 'Minha Conta',
    orders: 'Pedidos',
    ordersDescription: 'Acompanhe seus pedidos e veja o histórico de compras',
    viewOrders: 'Ver Pedidos',
    personalInfo: 'Dados Pessoais',
    personalInfoDescription: 'Gerencie suas informações pessoais e dados de contato',
    editProfile: 'Editar Perfil',
    addresses: 'Endereços',
    addressesDescription: 'Gerencie seus endereços de entrega',
    manageAddresses: 'Gerenciar Endereços',
    favorites: 'Favoritos',
    favoritesDescription: 'Veja sua lista de produtos favoritos',
    viewFavorites: 'Ver Favoritos',
    security: 'Segurança',
    securityDescription: 'Altere sua senha e gerencie a segurança da conta',
    managePassword: 'Alterar Senha',
    logout: 'Sair',
    logoutDescription: 'Encerre sua sessão no sistema',
    signOut: 'Sair da Conta',
    settings: 'Configurações do Sistema',
    settingsDescription: 'Configure dados financeiros, conteúdo do site e informações da empresa',
    manageSettings: 'Gerenciar Configurações',
  },

  project: {
    selectProject: 'Selecione um projeto',
    changeConfirmation: {
      title: 'Trocar de Projeto',
      message: 'Ao trocar de projeto, seu carrinho atual será limpo. Deseja continuar?',
      confirm: 'Sim, trocar projeto',
      cancel: 'Cancelar',
      success: 'Projeto alterado com sucesso!',
      error: 'Erro ao trocar de projeto. Tente novamente.'
    }
  },
  location: {
    selectLocation: 'Selecione uma filial',
    confirmChange: {
      title: 'Trocar de Filial',
      message: 'Você está trocando para a filial:',
      confirm: 'Sim, trocar filial',
      cancel: 'Cancelar'
    }
  },
    systemSettings: {
      title: 'Configurações do Sistema',
      financial: 'Configurações Financeiras',
      financialDescription: 'Gerencie dados financeiros, métodos de pagamento e configurações fiscais',
      systemMessages: 'Mensagens do Sistema',
      systemMessagesDescription: 'Gerenciar mensagens personalizadas exibidas no site (checkout, ficha do produto)',
      manageSystemMessages: 'Gerenciar Mensagens',
    manageFinancial: 'Gerenciar configurações financeiras',
    content: 'Conteúdo do Site',
    contentDescription: 'Configure as páginas de história, fornecedores e carreiras da empresa',
    manageContent: 'Gerenciar conteúdo',
    company: 'Informações da Empresa',
    companyDescription: 'Atualize email, endereço e telefone da empresa',
    manageCompany: 'Gerenciar dados da empresa',
    users: 'Configurações de Usuários',
    usersDescription: 'Gerencie usuários do sistema, perfis e permissões',
    manageUsers: 'Gerenciar usuários',
    home: 'Página Inicial',
    orders: 'Relatório de Pedidos',
    ordersDescription: 'Visualize e exporte relatórios detalhados de todos os pedidos',
    manageOrders: 'Gerenciar relatórios de pedidos',

    // Configurações de Categorias/Produtos
    categoryProduct: 'Categorias e Produtos',
    categoryProductDescription: 'Gerencie a visibilidade de categorias e produtos no site.',
    manageCategoryProduct: 'Gerenciar Categorias e Produtos',
    searchCategories: 'Buscar categorias...',
    exactSearchTip: 'Use aspas duplas ("") para buscar categorias com nome exato',
    searchProducts: 'Buscar produtos...',
    showDisabled: 'Mostrar desativados',
    showOnlyWithProducts: 'Mostrar apenas categorias com produtos',
    noCategories: 'Nenhuma categoria encontrada',
    noProducts: 'Nenhum produto encontrado nesta categoria',
    noDescription: 'Sem descrição',
    enabled: 'Ativado',
    disabled: 'Desativado',
    showProducts: 'Ver produtos',
    hideProducts: 'Ocultar produtos',
    product: 'Produto',
    sku: 'SKU',
    price: 'Preço',
    status: 'Status',
    categoryEnabled: 'Categoria ativada com sucesso',
    categoryDisabled: 'Categoria desativada com sucesso',
    productEnabled: 'Produto ativado com sucesso',
    productDisabled: 'Produto desativado com sucesso',
    productActivated: 'Produto "{name}" ativado com sucesso',
    productDeactivated: 'Produto "{name}" desativado com sucesso',
    errorLoadingCategories: 'Erro ao carregar categorias',
    errorUpdatingCategory: 'Erro ao atualizar categoria',
    errorUpdatingProduct: 'Erro ao atualizar produto',
    noProductsInCategory: 'Sem produtos'
  },
  users: {
    searchPlaceholder: 'Buscar por nome ou email...',
    allProfiles: 'Todos os Perfis',
    admin: 'Administrador',
    manager: 'Gerente',
    user: 'Usuário',
    name: 'Nome',
    email: 'Email',
    profile: 'Perfil',
    actions: 'Ações',
    noUsersFound: 'Nenhum usuário encontrado',
    loadError: 'Erro ao carregar usuários',
    updateSuccess: 'Perfil do usuário atualizado com sucesso',
    updateError: 'Erro ao atualizar perfil do usuário',
    editUser: 'Editar Usuário',
    addUser: 'Adicionar Usuário',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    password: 'Senha',
    firstNamePlaceholder: 'Digite o nome',
    lastNamePlaceholder: 'Digite o sobrenome',
    emailPlaceholder: 'Digite o endereço de email',
    passwordPlaceholder: 'Digite a senha',
    changePassword: 'Trocar a senha',
    selectProfile: 'Selecione o perfil',
    fillAllFields: 'Por favor, preencha todos os campos obrigatórios',
    createSuccess: 'Usuário criado com sucesso',
    createError: 'Erro ao criar usuário',
    showing: 'Mostrando',
    of: 'de',
    items: 'itens'
  },

  financial: {
    title: 'Configurações Financeiras',
    currencyCode: 'Código da Moeda',
    currencyCodePlaceholder: 'Digite o código da moeda (ex: BRL)',
    currencySymbol: 'Símbolo da Moeda',
    currencySymbolPlaceholder: 'Digite o símbolo da moeda (ex: R$)',
    taxRate: 'Taxa de Imposto',
    taxRatePlaceholder: 'Digite a taxa de imposto',
    discountPercentage: 'Porcentual de Desconto',
    discountPercentagePlaceholder: 'Digite a porcentagem de desconto',
    minOrderValue: 'Valor Mínimo do Pedido',
    minOrderValuePlaceholder: 'Digite o valor mínimo do pedido',
    freeShippingThreshold: 'Valor Mínimo para Frete Grátis',
    freeShippingThresholdPlaceholder: 'Digite o valor mínimo para frete grátis',
    loadError: 'Erro ao carregar as configurações financeiras',
    updateError: 'Erro ao atualizar as configurações financeiras',
    updateSuccess: 'Configurações financeiras atualizadas com sucesso',
    requiredFieldsError: 'Por favor, preencha todos os campos obrigatórios',
    fieldRequired: 'Este campo é obrigatório',
    shippingCost: 'Valor do Frete',
    shippingCostPlaceholder: 'Digite o valor do frete',
    enableAllFields: 'Habilitar Todos os Campos',
    enableAllFieldsDescription: 'Alterne para habilitar ou desabilitar todos os campos de uma vez',
    noPermission: 'Você não tem permissão para editar estas configurações',
    noPermissionToSave: 'Apenas administradores podem salvar alterações',
    readOnlyMode: 'Modo Somente Leitura',
    viewOnlyAccess: 'Como gerente, você pode apenas visualizar as configurações atuais, mas não pode modificá-las.'
  },
  systemMessages: {
    title: 'Mensagens do Sistema',
    loadError: 'Erro ao carregar mensagens',
    updateSuccess: 'Mensagens atualizadas com sucesso',
    updateError: 'Erro ao atualizar mensagens',
    noPermission: 'Você não tem permissão para modificar essas configurações',
    readOnlyMode: 'Modo somente leitura',
    viewOnlyAccess: 'Você pode apenas visualizar essas configurações',
    requiredFieldsError: 'Por favor, preencha todos os campos em todos os idiomas',
    french: 'Francês',
    english: 'Inglês',
    portuguese: 'Português',
    checkoutPriceDisclaimer: {
      title: 'Aviso de Preço (Checkout)',
      description: 'Mensagem exibida na seção Carrinho do checkout',
      placeholderFr: 'Les prix présentés sur le site peuvent varier. Le prix final sera validé dans votre confirmation de commande',
      placeholderEn: 'Prices shown on the site may vary. The final price will be validated in your order confirmation',
      placeholderPt: 'Os preços apresentados no site podem variar. O preço final será validado na sua confirmação de pedido'
    },
    productTransferInfo: {
      title: 'Informação de Transferência (Ficha do Produto)',
      description: 'Mensagem exibida na página de detalhes do produto',
      placeholderFr: 'Pour un transfert d\'une autre succursale, prévoir un délai d\'environs 24 heures. Pour toute urgence, communiquer avec nous.',
      placeholderEn: 'For a transfer from another branch, allow approximately 24 hours. For any urgency, contact us.',
      placeholderPt: 'Para uma transferência de outra filial, prever um prazo de aproximadamente 24 horas. Para qualquer urgência, entre em contato conosco.'
    }
  },
  profile: {
    title: 'Editar Perfil',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Telefone',
    firstNamePlaceholder: 'Digite seu nome',
    lastNamePlaceholder: 'Digite seu sobrenome',
    emailPlaceholder: 'Digite seu e-mail',
    phonePlaceholder: 'Digite seu telefone',
    save: 'Salvar',
    saving: 'Salvando...',
    requiredFieldsError: 'Por favor, preencha todos os campos obrigatórios',
    updateError: 'Erro ao atualizar perfil. Por favor, tente novamente.',
    updateSuccess: 'Perfil atualizado com sucesso!'
  },

  ordersSettings: {
    title: 'Relatório de Pedidos',
    filters: 'Filtros',
    dateRange: 'Período',
    product: 'Produto',
    productPlaceholder: 'Digite o nome do produto...',
    city: 'Cidade',
    cityPlaceholder: 'Digite a cidade...',
    projects: 'Projetos',
    projectsPlaceholder: 'Selecione os projetos...',
    pickupLocation: 'Local de Retirada',
    pickupAt: 'Retirada em',
    noLocationSpecified: 'Nenhum local especificado',
    contactOnSite: 'Contato no Local',
    contactPhone: 'Telefone de Contato',
    deliveryDate: 'Data de Entrega',
    deliveryDateTime: 'Data de Entrega',
    specialInstructions: 'Instruções Especiais de Entrega',
    poNumber: 'Número do Pedido de Compra',
    additionalInfo: 'Informações Adicionais',
    multiselect: {
      noResult: 'Nenhum resultado encontrado',
      noOptions: 'Lista vazia',
      selectLabel: 'Pressione enter para selecionar',
      selectedLabel: 'Selecionado',
      deselectLabel: 'Pressione enter para remover',
      placeholder: 'Selecione uma opção',
      loading: 'Carregando...',
      loadingMore: 'Carregando mais...',
      searching: 'Buscando...',
      maxElements: 'Limite atingido',
      maxElementsText: 'Limite de {max} elementos atingido',
      noElements: 'Nenhum elemento encontrado',
    },
    applyFilters: 'Aplicar Filtros',
    resetFilters: 'Limpar Filtros',
    exportToExcel: 'Exportar para Excel',
    exporting: 'Exportando...',
    ordersList: 'Lista de Pedidos',
    sortBy: 'Ordenar por',
    dateNewest: 'Data: Mais recente',
    dateOldest: 'Data: Mais antigo',
    totalHighest: 'Valor: Maior para menor',
    totalLowest: 'Valor: Menor para maior',
    orderNumber: 'Número do Pedido',
    orderNumberSearch: 'Pesquisa por nº do pedido',
    orderNumberPlaceholder: 'Ex.: 2025- ou número completo',
    printOrder: 'Imprimir',
    printOrderTitle: 'Abrir para impressão ou PDF',
    printPriceOnRequest: 'Sob consulta',
    printDocumentTitle: 'Pedido',
    printHeading: 'Resumo do pedido',
    printSummaryTitle: 'Resumo',
    printDeliverySection: 'Entrega e detalhes',
    printFooter: 'Empire Canada — Obrigado pela preferência.',
    printPopupBlocked: 'Permita pop-ups neste site para imprimir o pedido.',
    printError: 'Não foi possível carregar o pedido para impressão.',
    pdfViewerTitle: 'Pedido',
    downloadPdf: 'Descarregar PDF',
    printPdf: 'Imprimir',
    closePdf: 'Fechar',
    loadingPdf: 'A carregar PDF…',
    pdfLoadError: 'Não foi possível gerar o PDF do pedido.',
    customerEmail: 'E-mail do cliente',
    customerPhone: 'Telefone do cliente',
    deliveryMethod: 'Tipo de entrega',
    deliveryMethodDelivery: 'Entrega',
    deliveryMethodPickup: 'Retirada',
    branch: 'Filial',
    noBranch: 'Sem filial',
    neovationOrder: 'Referência Neovation',
    clientId: 'ID do cliente',
    productCode: 'Código do produto',
    date: 'Data',
    project: 'Projeto',
    total: 'Total',
    status: 'Status',
    actions: 'Ações',
    viewDetails: 'Ver Detalhes',
    noOrdersFound: 'Nenhum pedido encontrado',
    previous: 'Anterior',
    next: 'Próximo',
    noProject: 'Sem projeto',
    orderDetails: 'Detalhes do Pedido',
    orderInfo: 'Informações do Pedido',
    shippingAddress: 'Endereço de Entrega',
    orderItems: 'Itens do Pedido',
    quantity: 'Quantidade',
    excel: {
      fileName: 'Pedidos_Empire_Canada',
      orderNumber: 'Número do Pedido',
      date: 'Data',
      project: 'Projeto',
      status: 'Status',
      product: 'Produto',
      quantity: 'Quantidade',
      unitPrice: 'Preço Unitário',
      totalPrice: 'Preço Total',
      address: 'Endereço',
      number: 'Número',
      complement: 'Complemento',
      neighborhood: 'Bairro',
      city: 'Cidade',
      state: 'Estado',
      postalCode: 'CEP',
      country: 'País',
      shippingCost: 'Frete',
      taxAmount: 'Impostos',
      orderTotal: 'Total do Pedido',
      notes: 'Observações'
    },
    unitPrice: 'Preço Unitário',
    totalPrice: 'Preço Total',
    color: 'Cor',
    size: 'Tamanho',
    weight: 'Peso',
    unit: 'Unidade',
    subtotal: 'Subtotal',
    shippingCost: 'Frete',
    taxAmount: 'Impostos',
    notes: 'Observações',
    status_pending: 'Pendente',
    status_processing: 'Em processamento',
    status_completed: 'Concluído',
    status_cancelled: 'Cancelado',
    updateStatus: 'Atualizar Status',
    updateOrderStatus: 'Atualizar Status do Pedido',
    currentStatus: 'Status Atual',
    newStatus: 'Novo Status',
    cancel: 'Cancelar',
    updating: 'Atualizando',
    errorUpdatingStatus: 'Erro ao atualizar status do pedido',
    updateStatus: 'Atualizar Status',
    updateOrderStatus: 'Atualizar Status do Pedido',
    currentStatus: 'Status Atual',
    newStatus: 'Novo Status',
    cancel: 'Cancelar',
    updating: 'Atualizando',
    errorUpdatingStatus: 'Erro ao atualizar status do pedido'
  },
  orders: {
    title: 'Meus Pedidos',
    orderNumber: 'Pedido #{number}',
    noOrders: 'Você ainda não fez nenhum pedido',
    noOrdersForFilter: 'Nenhum pedido encontrado com esse número.',
    clearOrderFilter: 'Limpar filtro',
    startShopping: 'Começar a Comprar',
    fetchError: 'Erro ao carregar pedidos. Por favor, tente novamente.',
    quantity: 'Quantidade',
    status: {
      pending: 'Pendente',
      processing: 'Em Processamento',
      completed: 'Concluído',
      cancelled: 'Cancelado'
    },
    shipping: 'Frete',
    taxes: 'Impostos',
    total: 'Total',
    notes: 'Observações do Pedido',
    noNotes: 'Nenhuma observação para este pedido',
    shippingAddress: 'Endereço de Entrega',
    pickupLocation: 'Local de Retirada',
    pickupAt: 'Retirada em',
    noLocationSpecified: 'Nenhum local especificado',
    noShippingAddress: 'Nenhum endereço de entrega disponível',
    landmark: 'Ponto de Referência',
    noPriceOrder: 'Pedido sem preços',
    additionalInfo: 'Informações Adicionais',
    project: 'Projeto',
    projectId: 'ID do Projeto',
    noProject: 'Nenhum projeto associado',
    branch: 'Filial',
    noBranch: 'Nenhuma filial associada',
    contactOnSite: 'Contato no Local',
    contactPhone: 'Telefone de Contato',
    deliveryDate: 'Data de Entrega',
    deliveryDateTime: 'Data de Entrega',
    specialInstructions: 'Instruções Especiais de Entrega',
    poNumber: 'Número do Pedido de Compra'
  },
  security: {
    title: 'Segurança',
    currentPassword: 'Senha atual',
    newPassword: 'Nova senha',
    confirmNewPassword: 'Confirmar nova senha',
    updatePassword: 'Atualizar senha',
    passwordUpdated: 'Senha atualizada com sucesso',
    currentPasswordIncorrect: 'Senha atual incorreta',
    updateError: 'Erro ao atualizar senha',
    allFieldsRequired: 'Todos os campos são obrigatórios',
    passwordsDoNotMatch: 'As senhas não coincidem',
    passwordTooShort: 'A senha deve ter pelo menos 6 caracteres'
  },
  company: {
    name: 'Nome da Empresa',
    namePlaceholder: 'Digite o nome da empresa',
    email: 'E-mail',
    emailPlaceholder: 'Digite o e-mail da empresa',
    phone: 'Telefone',
    phonePlaceholder: 'Digite o telefone da empresa',
    website: 'Website',
    websitePlaceholder: 'Digite o website da empresa',
    websiteHint: 'Exemplo: www.exemplo.com ou https://exemplo.com',
    address: 'Endereço',
    addressPlaceholder: 'Digite o endereço da empresa',
    loadError: 'Erro ao carregar dados da empresa',
    updateSuccess: 'Informações da empresa atualizadas com sucesso',
    updateError: 'Erro ao atualizar informações da empresa',
    requiredFieldsError: 'Por favor, preencha todos os campos obrigatórios',
    fieldRequired: 'Este campo é obrigatório',
    saving: 'Salvando...',
    save: 'Salvar',
    contacts: {
      sectionTitle: 'Contatos da Empresa',
      title: 'Gerenciar Contatos',
      manage: 'Gerenciar Contatos',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefone',
      address: 'Endereço',
      department: 'Departamento',
      add: 'Adicionar Contato',
      edit: 'Editar Contato',
      deleteConfirmation: 'Excluir Contato',
      deleteWarning: 'Esta ação não pode ser desfeita. Tem certeza que deseja excluir este contato?'
    }
  },
  content: {
    history: {
      title: 'Nossa História',
      description: 'Gerenciar conteúdo da história da empresa, linha do tempo e marcos',
      manage: 'Gerenciar história',
      breadcrumb: 'História',
      form: {
        title: 'Título',
        titlePlaceholder: 'Digite o título da seção...',
        content: 'Conteúdo',
        contentPlaceholder: 'Digite o conteúdo da seção...',
        year: 'Ano',
        yearPlaceholder: 'Digite o ano...',
        add: 'ADICIONAR SEÇÃO',
        edit: 'EDITAR SEÇÃO',
        cancel: 'Cancelar'
      },
      actions: {
        hide: 'Ocultar seção',
        show: 'Mostrar seção',
        edit: 'Editar seção',
        delete: 'Excluir seção'
      },
      confirmDelete: 'Tem certeza que deseja excluir esta seção?',
      deleteModal: {
        title: "Confirmar exclusão",
        message: "Tem certeza que deseja excluir este item do histórico? Esta ação não pode ser desfeita.",
        cancel: "Cancelar",
        confirm: "Excluir"
      },
      messages: {
        addSuccess: 'Seção adicionada com sucesso',
        updateSuccess: 'Seção atualizada com sucesso',
        deleteSuccess: 'Seção excluída com sucesso',
        visibilitySuccess: 'Visibilidade da seção atualizada com sucesso',
        loadError: 'Erro ao carregar itens do histórico',
        addError: 'Erro ao adicionar seção',
        updateError: 'Erro ao atualizar seção',
        deleteError: 'Erro ao excluir seção',
        visibilityError: 'Erro ao atualizar visibilidade da seção',
        deleteSuccess: "Item excluído com sucesso",
        deleteError: "Erro ao excluir item"
      },
      loading: 'Carregando...',
      fetchError: 'Erro ao carregar o histórico',
      foundation: {
        title: 'Fundação',
        text: 'Fundada em 1945, a Empire Canada começou como uma pequena loja familiar de materiais hidráulicos em Montreal. A visão de nossos fundadores era fornecer produtos de qualidade e serviço excepcional para empreiteiros locais e proprietários.'
      },
      growth: {
        title: 'Crescimento e Evolução',
        text: 'Através de décadas de dedicação e inovação, expandimos nossas operações por todo o Canadá, nos estabelecendo como um fornecedor líder na indústria de hidráulica e aquecimento.'
      },
      today: {
        title: 'Empire Hoje',
        text: 'Hoje, a Empire Canada é uma distribuidora nacional com mais de 50 locais, atendendo milhares de profissionais e mantendo nosso compromisso com qualidade e atendimento ao cliente.'
      }
    },
    suppliers: {
      title: "Fornecedores",
      description: "Gerenciar conteúdo dos fornecedores",
      manage: "Gerenciar fornecedores",
      breadcrumb: "Fornecedores",
      form: {
        title: "Título",
        titlePlaceholder: "Digite o título",
        content: "Conteúdo",
        contentPlaceholder: "Digite o conteúdo",
        add: "ADICIONAR SEÇÃO",
        edit: "Salvar alterações",
        cancel: "Cancelar"
      },
      actions: {
        edit: "Editar item",
        delete: "Excluir item",
        show: "Mostrar item",
        hide: "Ocultar item"
      },
      deleteModal: {
        title: "Excluir Fornecedor",
        message: "Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.",
        confirm: "Excluir",
        cancel: "Cancelar"
      },
      messages: {
        addSuccess: "Fornecedor adicionado com sucesso",
        updateSuccess: "Fornecedor atualizado com sucesso",
        deleteSuccess: "Fornecedor excluído com sucesso",
        visibilitySuccess: "Visibilidade atualizada com sucesso",
        loadError: "Erro ao carregar fornecedores",
        addError: "Erro ao adicionar fornecedor",
        updateError: "Erro ao atualizar fornecedor",
        deleteError: "Erro ao excluir fornecedor",
        visibilityError: "Erro ao atualizar visibilidade"
      }
    },
    career: {
      title: 'Carreira',
      description: 'Gerencie oportunidades de trabalho, requisitos e processo de candidatura',
      manage: 'Gerenciar carreira',
      breadcrumb: 'Carreira',
      form: {
        title: 'Vaga',
        titlePlaceholder: 'Digite o nome da vaga...',
        content: 'Descrição da vaga',
        contentPlaceholder: 'Digite a descrição da vaga...',
        add: 'ADICIONAR VAGA',
        edit: 'EDITAR VAGA',
        cancel: 'Cancelar'
      },
      actions: {
        hide: 'Ocultar seção',
        show: 'Mostrar seção',
        edit: 'Editar seção',
        delete: 'Excluir seção'
      },
      modal: {
        deleteTitle: 'Confirmar exclusão',
        deleteMessage: 'Tem certeza que deseja excluir esta seção de carreira? Esta ação não pode ser desfeita.',
        cancel: 'Cancelar',
        confirm: 'Excluir'
      },
      messages: {
        addSuccess: 'Seção adicionada com sucesso',
        updateSuccess: 'Seção atualizada com sucesso',
        deleteSuccess: 'Seção excluída com sucesso',
        visibilitySuccess: 'Visibilidade da seção atualizada com sucesso',
        loadError: 'Erro ao carregar itens de carreira',
        addError: 'Erro ao adicionar seção',
        updateError: 'Erro ao atualizar seção',
        deleteError: 'Erro ao excluir seção',
        visibilityError: 'Erro ao atualizar visibilidade da seção'
      }
    }
  },
  addresses: {
    title: 'Meus Endereços',
    address: 'Endereço',
    addNew: 'Adicionar Novo Endereço',
    street: 'Rua',
    streetPlaceholder: 'Digite o nome da rua',
    number: 'Número',
    numberPlaceholder: 'Digite o número',
    complement: 'Complemento',
    complementPlaceholder: 'Digite o complemento (opcional)',
    neighborhood: 'Bairro',
    neighborhoodPlaceholder: 'Digite o bairro',
    city: 'Cidade',
    cityPlaceholder: 'Digite a cidade',
    state: 'Estado',
    statePlaceholder: 'Digite o estado',
    postalCode: 'CEP',
    postalCodePlaceholder: 'Digite o CEP',
    setAsDefault: 'Definir como endereço padrão',
    deleteConfirm: 'Tem certeza que deseja excluir este endereço?',
    saveSuccess: 'Endereço salvo com sucesso',
    deleteSuccess: 'Endereço excluído com sucesso',
    deleteError: 'Erro ao excluir endereço',
    error: 'Ocorreu um erro. Por favor, tente novamente.',
    default: 'Padrão',
    requiredField: 'Este campo é obrigatório',
    saveSuccess: 'Endereços salvos com sucesso',
    saveError: 'Erro ao salvar endereços',
    loadError: 'Erro ao carregar endereços',
    deleteConfirm: 'Tem certeza que deseja excluir este endereço?',
    deleteSuccess: 'Endereço excluído com sucesso',
    deleteError: 'Erro ao excluir endereço',
    fillAllRequired: 'Preencha todos os campos obrigatórios',
    deleteModal: {
      title: 'Excluir Endereço',
      message: 'Tem certeza que deseja excluir este endereço? Esta ação não pode ser desfeita.',
      cancel: 'Cancelar',
      confirm: 'Excluir'
    },
    noAddresses: 'Você não possui endereços cadastrados'
  },
  suppliers: {
    pageTitle: 'Nossos Fornecedores',
    title: 'Nossos Fornecedores'
  },
  history: {
    pageTitle: 'Nossa História',
    title: 'Nossa História'
  },
  accessDenied: {
    title: 'Acesso Negado',
    message: 'Você não tem permissão para acessar esta página. Esta área é restrita apenas a administradores e gerentes.',
    goHome: 'Ir para a Página Inicial',
    goToAccount: 'Ir para Minha Conta'
  },
  pagination: {
    showing: 'Mostrando',
    of: 'de',
    prev: 'Anterior',
    next: 'Próximo',
    itemsPerPage: 'Itens por página'
  },

  breadcrumb: {
    home: 'Início'
  },

  settings: {
    home: {
      title: 'Página Inicial',
      description: 'Gerencie a banner principal da página inicial, incluindo imagens, títulos e cores.',
      manage: 'Gerenciar Banners'
    }
  },

  homeBanner: {
    title: 'Banners da Página Inicial',
    addNew: 'Adicionar Novo',
    image: 'Imagem',
    title: 'Título',
    subtitle: 'Subtítulo',
    status: 'Status',
    position: 'Posição',
    actions: 'Ações',
    active: 'Ativo',
    inactive: 'Inativo',
    edit: 'Editar',
    delete: 'Excluir',
    noBanners: 'Nenhum banner encontrado',
    addBanner: 'Adicionar Banner',
    editBanner: 'Editar Banner',
    titleColor: 'Cor do Título',
    subtitleColor: 'Cor do Subtítulo',
    isActive: 'Banner Ativo',
    chooseFile: 'Escolher Arquivo',
    noFileChosen: 'Nenhum arquivo selecionado',
    imageRequirements: 'Recomendado: 1920x1080px, máximo 2MB, formatos: JPG, PNG, GIF, WEBP',
    invalidImageType: 'Tipo de arquivo inválido. Por favor, use JPG, PNG, GIF ou WEBP.',
    imageTooLarge: 'Imagem muito grande. O tamanho máximo é 2MB.',
    confirmDelete: 'Confirmar Exclusão',
    deleteWarning: 'Tem certeza que deseja excluir este banner? Esta ação não pode ser desfeita.',
    fetchError: 'Erro ao carregar os banners. Por favor, tente novamente.',
    saveError: 'Erro ao salvar o banner. Por favor, tente novamente.',
    deleteError: 'Erro ao excluir o banner. Por favor, tente novamente.',
    createSuccess: 'Banner criado com sucesso!',
    updateSuccess: 'Banner atualizado com sucesso!',
    deleteSuccess: 'Banner excluído com sucesso!',
    titlePlaceholderPt: 'Digite o título em português',
    titlePlaceholderEn: 'Digite o título em inglês',
    titlePlaceholderFr: 'Digite o título em francês',
    subtitlePlaceholderPt: 'Digite o subtítulo em português',
    subtitlePlaceholderEn: 'Digite o subtítulo em inglês',
    subtitlePlaceholderFr: 'Digite o subtítulo em francês',
    buttonText: 'Texto do Botão',
    buttonTextPlaceholderPt: 'Digite o texto do botão em português',
    buttonTextPlaceholderEn: 'Digite o texto do botão em inglês',
    buttonTextPlaceholderFr: 'Digite o texto do botão em francês',
    buttonTextHint: 'Deixe vazio para usar o texto padrão "Shop Now"',
    buttonLink: 'Link do Botão',
    buttonLinkPlaceholder: 'Ex: /categories ou https://example.com',
    buttonLinkHint: 'Link interno (ex: /categories) ou externo (ex: https://example.com). Deixe vazio para usar /categories'
  },

  homeTabs: {
    banner: 'Banners',
    logo: 'Logo do Sistema',
    brands: 'Marcas'
  },

  logo: {
    title: 'Logo do Sistema',
    addNew: 'Adicionar Nova',
    image: 'Imagem',
    name: 'Nome',
    description: 'Descrição',
    status: 'Status',
    actions: 'Ações',
    active: 'Ativa',
    inactive: 'Inativa',
    edit: 'Editar',
    delete: 'Excluir',
    noLogos: 'Nenhuma logo encontrada',
    addLogo: 'Adicionar Logo',
    editLogo: 'Editar Logo',
    isActive: 'Logo Ativa',
    chooseFile: 'Escolher Arquivo',
    noFileChosen: 'Nenhum arquivo selecionado',
    imageRequirements: 'Recomendado: PNG com fundo transparente, máximo 1MB',
    invalidImageType: 'Tipo de arquivo inválido. Por favor, use PNG ou SVG.',
    imageTooLarge: 'Imagem muito grande. O tamanho máximo é 1MB.',
    confirmDelete: 'Confirmar Exclusão',
    deleteWarning: 'Tem certeza que deseja excluir esta logo? Esta ação não pode ser desfeita.',
    cannotDeleteActive: 'Não é possível excluir a logo ativa. Por favor, ative outra logo primeiro.',
    cannotDeleteOnly: 'Não é possível excluir a única logo do sistema.',
    fetchError: 'Erro ao carregar as logos. Por favor, tente novamente.',
    saveError: 'Erro ao salvar a logo. Por favor, tente novamente.',
    deleteError: 'Erro ao excluir a logo. Por favor, tente novamente.',
    createSuccess: 'Logo criada com sucesso!',
    updateSuccess: 'Logo atualizada com sucesso!',
    deleteSuccess: 'Logo excluída com sucesso!',
    activateSuccess: 'Logo ativada com sucesso!',
    activeInfo: 'Apenas uma logo pode estar ativa por vez. A logo ativa será exibida no cabeçalho e rodapé do site.',
    firstLogoActive: 'Esta é a primeira logo do sistema e será definida como ativa automaticamente.',
    cannotDeactivateOnly: 'Não é possível desativar a única logo ativa. Pelo menos uma logo deve estar ativa no sistema.'
  },

  brand: {
    title: 'Marcas',
    addNew: 'Adicionar Nova',
    image: 'Imagem',
    name: 'Nome',
    description: 'Descrição',
    status: 'Status',
    position: 'Posição',
    actions: 'Ações',
    active: 'Ativa',
    inactive: 'Inativa',
    edit: 'Editar',
    delete: 'Excluir',
    noBrands: 'Nenhuma marca encontrada',
    addBrand: 'Adicionar Marca',
    editBrand: 'Editar Marca',
    isActive: 'Marca Ativa',
    chooseFile: 'Escolher Arquivo',
    noFileChosen: 'Nenhum arquivo selecionado',
    imageRequirements: 'Recomendado: PNG com fundo transparente, máximo 1MB',
    invalidImageType: 'Tipo de arquivo inválido. Por favor, use PNG ou SVG.',
    imageTooLarge: 'Imagem muito grande. O tamanho máximo é 1MB.',
    confirmDelete: 'Confirmar Exclusão',
    deleteWarning: 'Tem certeza que deseja excluir esta marca? Esta ação não pode ser desfeita.',
    fetchError: 'Erro ao carregar as marcas. Por favor, tente novamente.',
    saveError: 'Erro ao salvar a marca. Por favor, tente novamente.',
    deleteError: 'Erro ao excluir a marca. Por favor, tente novamente.',
    createSuccess: 'Marca criada com sucesso!',
    updateSuccess: 'Marca atualizada com sucesso!',
    deleteSuccess: 'Marca excluída com sucesso!'
  }
}
